import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Star, ShieldCheck } from 'lucide-react';
import { SwipeButton } from './SwipeButton';
interface TaskCardProps {
  id: string;
  title: string;
  avatar: string;
  name: string;
  distance: string;
  reward: string;
  urgency: string;
  urgencyColor: string;
  isExpanded?: boolean;
  trustScore?: number;
  completedTasks?: number;
}
export function TaskCard({
  id,
  title,
  avatar,
  name,
  distance,
  reward,
  urgency,
  urgencyColor,
  isExpanded = false,
  trustScore,
  completedTasks
}: TaskCardProps) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-[#12121a] rounded-2xl p-4 border border-[#2a2a35] shadow-lg overflow-hidden" data-id="element-35">
      <div className="flex justify-between items-start mb-3" data-id="element-36">
        <div className="flex items-center gap-3" data-id="element-37">
          <img src={avatar} alt={name} className="w-10 h-10 rounded-full object-cover border border-[#2a2a35]" data-id="element-38" />
          <div data-id="element-39">
            <h3 className="text-white font-semibold text-base leading-tight" data-id="element-40">
              {title}
            </h3>
            <p className="text-[#a0a0ab] text-sm" data-id="element-41">{name}</p>
          </div>
        </div>
        <div className="bg-[#1a1a24] px-3 py-1.5 rounded-xl border border-[#2a2a35] flex flex-col items-end" data-id="element-42">
          <span className="text-[#4ade80] font-bold text-lg leading-none" data-id="element-43">
            {reward}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3 text-sm mb-4" data-id="element-44">
        <div className="flex items-center text-[#a0a0ab]" data-id="element-45">
          <MapPin className="w-4 h-4 mr-1" data-id="element-46" />
          {distance}
        </div>
        <div className="w-1 h-1 rounded-full bg-[#2a2a35]" data-id="element-47" />
        <div className={`flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${urgencyColor}`} data-id="element-48">
          <Clock className="w-3 h-3 mr-1" data-id="element-49" />
          {urgency}
        </div>
      </div>

      {isExpanded && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="mb-4 space-y-4" data-id="element-50">
          <div className="h-32 w-full rounded-xl bg-[#1a1a24] border border-[#2a2a35] overflow-hidden relative" data-id="element-51">
            {/* Simulated Map */}
            <div className="absolute inset-0 opacity-40" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=800&auto=format&fit=crop")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'grayscale(100%) contrast(120%)'
        }} data-id="element-52" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#12121a] to-transparent" data-id="element-53" />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-54">
              <div className="w-12 h-12 bg-[#4ade80]/20 rounded-full flex items-center justify-center animate-pulse" data-id="element-55">
                <div className="w-4 h-4 bg-[#4ade80] rounded-full border-2 border-[#12121a]" data-id="element-56" />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between bg-[#1a1a24] p-3 rounded-xl border border-[#2a2a35]" data-id="element-57">
            <div className="flex items-center gap-2" data-id="element-58">
              <ShieldCheck className="w-5 h-5 text-[#4ade80]" data-id="element-59" />
              <div data-id="element-60">
                <p className="text-sm text-white font-medium" data-id="element-61">Trusted Poster</p>
                <p className="text-xs text-[#a0a0ab]" data-id="element-62">
                  {completedTasks} tasks completed
                </p>
              </div>
            </div>
            <div className="flex items-center gap-1 bg-[#12121a] px-2 py-1 rounded-lg" data-id="element-63">
              <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-64" />
              <span className="text-sm font-bold text-white" data-id="element-65">{trustScore}</span>
            </div>
          </div>
        </motion.div>}

      <SwipeButton onClaim={() => console.log(`Claimed task ${id}`)} data-id="element-66" />
    </motion.div>;
}